import { groupBy } from 'lodash';
import { IParameter } from '../../Parameters/types';
import { ITagGroup } from '../../TagGroups/types';
import { IProfile } from '../../Profiles/types';
import { IItem } from '../types';

export const mapDataToOptions = ({
  parameters,
  tagGroups,
  markets,
  allItems,
}: {
  parameters: IParameter[];
  tagGroups: ITagGroup[];
  markets: IProfile[];
  allItems: IItem[];
}) => {
  const parameterOptions = parameters.map(parameter => ({
    label: parameter.name,
    value: parameter,
  }));
  const tagGroupOptions = tagGroups.map(({ name, id }) => ({
    label: name,
    value: { name, id },
  }));
  const marketOptions = markets.map(({ name, id }) => ({
    label: name,
    value: { name, id },
  }));
  const { items = [], archivedItems = [] } = groupBy(allItems, item =>
    item.isDeleted ? 'archivedItems' : 'items'
  );

  return {
    parameterOptions,
    tagGroupOptions,
    marketOptions,
    items,
    archivedItems,
  };
};

export const mapItemsWithParameter = (items: IItem[]) =>
  items.map(item => ({
    parameterId: item.parameter && item.parameter.id,
    option: {
      label: item.name,
      value: {
        name: item.name,
        id: item.id,
        isDeleted: item.isDeleted,
      },
    },
  }));



// WEBPACK FOOTER //
// ./src/views/Admin/Items/services/mapDataToOptions.ts